/* Wonder Workbooks flip-book. No dependencies.
   Desktop (>= 720px wide viewer): leaves hold two pages (front = right page, back = left page of the next spread).
   Phone: one page per leaf, the back is blank paper and turns out of view. */
(function () {
  var TURN_MS = 700;

  function FlipBook(root) {
    this.root = root;
    this.pages = (root.getAttribute('data-pages') || '').split('|').filter(Boolean);
    this.dialog = root.querySelector('.ww-fb-dialog');
    this.stage = root.querySelector('.ww-fb-stage');
    this.book = root.querySelector('.ww-fb-book');
    this.count = root.querySelector('.ww-fb-count');
    this.prevBtn = root.querySelector('.ww-fb-prev');
    this.nextBtn = root.querySelector('.ww-fb-next');
    this.leaves = [];
    this.flipped = 0;
    this.spread = false;
    this.bind();
  }

  FlipBook.prototype.bind = function () {
    var self = this;
    this.root.querySelector('.ww-fb-open').addEventListener('click', function () { self.open(); });
    this.root.querySelector('.ww-fb-close').addEventListener('click', function () { self.close(); });
    this.prevBtn.addEventListener('click', function () { self.prev(); });
    this.nextBtn.addEventListener('click', function () { self.next(); });
    this.dialog.addEventListener('close', function () { document.documentElement.classList.remove('ww-fb-lock'); });
    this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.close(); });
    this.dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.next(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.prev(); }
    });
    // tap the right half to go forward, the left half to go back; swipe either way
    var startX = null, startY = null;
    this.stage.addEventListener('pointerdown', function (e) { startX = e.clientX; startY = e.clientY; });
    this.stage.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      startX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { dx < 0 ? self.next() : self.prev(); return; }
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8 && e.target.closest('.ww-fb-book')) {
        var r = self.book.getBoundingClientRect();
        (e.clientX - r.left > r.width / 2) ? self.next() : self.prev();
      }
    });
    var t;
    window.addEventListener('resize', function () {
      if (!self.dialog.open) return;
      clearTimeout(t);
      t = setTimeout(function () { self.build(self.currentPage()); }, 150);
    });
  };

  FlipBook.prototype.open = function () {
    document.documentElement.classList.add('ww-fb-lock');
    if (this.dialog.showModal) this.dialog.showModal(); else this.dialog.setAttribute('open', '');
    this.build(0);
    this.nextBtn.focus();
  };

  FlipBook.prototype.close = function () {
    if (this.dialog.close) this.dialog.close(); else this.dialog.removeAttribute('open');
    document.documentElement.classList.remove('ww-fb-lock');
  };

  // index of the first page currently showing, so a rebuild on resize keeps your place
  FlipBook.prototype.currentPage = function () {
    return this.spread ? Math.max(0, this.flipped * 2 - 1) : this.flipped;
  };

  FlipBook.prototype.face = function (src, back, n) {
    var f = document.createElement('div');
    f.className = 'ww-fb-face' + (back ? ' is-back' : '') + (src ? '' : ' is-blank');
    if (src) {
      var img = document.createElement('img');
      img.src = src; img.alt = 'Page ' + n; img.decoding = 'async';
      f.appendChild(img);
    }
    return f;
  };

  FlipBook.prototype.build = function (keepPage) {
    var stageW = this.stage.clientWidth - 32, stageH = this.stage.clientHeight - 16;
    var ratio = 1076 / 760;
    this.spread = stageW >= 688;
    var pageW = this.spread ? Math.min(stageW / 2, stageH / ratio) : Math.min(stageW, stageH / ratio);
    pageW = Math.floor(pageW);
    var pageH = Math.floor(pageW * ratio);
    this.pageW = pageW;
    this.book.innerHTML = '';
    this.book.style.width = (this.spread ? pageW * 2 : pageW) + 'px';
    this.book.style.height = pageH + 'px';
    this.leaves = [];
    var p = this.pages, i, leaf;
    var n = this.spread ? Math.ceil(p.length / 2) : p.length;
    for (i = 0; i < n; i++) {
      leaf = document.createElement('div');
      leaf.className = 'ww-fb-leaf';
      leaf.style.width = pageW + 'px';
      leaf.style.left = (this.spread ? pageW : 0) + 'px';
      if (this.spread) {
        leaf.appendChild(this.face(p[i * 2], false, i * 2 + 1));
        leaf.appendChild(this.face(p[i * 2 + 1] || null, true, i * 2 + 2));
      } else {
        leaf.appendChild(this.face(p[i], false, i + 1));
        leaf.appendChild(this.face(null, true));
      }
      this.book.appendChild(leaf);
      this.leaves.push(leaf);
    }
    var target = this.spread ? Math.ceil((keepPage || 0) / 2) : (keepPage || 0);
    this.flipped = Math.min(target, this.spread ? n : n - 1);
    for (i = 0; i < this.leaves.length; i++) {
      this.leaves[i].style.transition = 'none';
      this.leaves[i].classList.toggle('is-flipped', i < this.flipped);
    }
    this.book.offsetWidth; // apply without animating
    for (i = 0; i < this.leaves.length; i++) this.leaves[i].style.transition = '';
    this.update(-1);
  };

  FlipBook.prototype.update = function (moving) {
    var L = this.leaves.length, i;
    for (i = 0; i < L; i++) {
      this.leaves[i].style.zIndex = (i === moving) ? 3 * L : (i < this.flipped ? i + 1 : 2 * L - i);
    }
    var total = this.pages.length;
    var last = this.spread ? L : L - 1;
    if (this.spread) {
      // centre the closed cover and the closed back, like a real book on a table
      var shift = this.flipped === 0 ? -this.pageW / 2 : (this.flipped === L && total % 2 === 0 ? this.pageW / 2 : 0);
      this.book.style.transform = 'translateX(' + shift + 'px)';
      var left = this.flipped * 2, right = this.flipped * 2 + 1;
      this.count.textContent = this.flipped === 0 ? '1 / ' + total : (right > total ? left + ' / ' + total : left + '-' + right + ' / ' + total);
    } else {
      this.book.style.transform = '';
      this.count.textContent = (this.flipped + 1) + ' / ' + total;
    }
    this.prevBtn.disabled = this.flipped === 0;
    this.nextBtn.disabled = this.flipped >= last;
    if (moving >= 0) {
      var self = this;
      clearTimeout(this._z);
      this._z = setTimeout(function () { self.update(-1); }, TURN_MS);
    }
  };

  FlipBook.prototype.next = function () {
    var last = this.spread ? this.leaves.length : this.leaves.length - 1;
    if (this.flipped >= last) return;
    var k = this.flipped;
    this.flipped++;
    this.update(k);
    this.leaves[k].classList.add('is-flipped');
  };

  FlipBook.prototype.prev = function () {
    if (this.flipped === 0) return;
    this.flipped--;
    var k = this.flipped;
    this.update(k);
    this.leaves[k].classList.remove('is-flipped');
  };

  function init() {
    var roots = document.querySelectorAll('[data-ww-fb]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i]._wwfb) roots[i]._wwfb = new FlipBook(roots[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
